







































































import {
    defineComponent,
    inject,
    watch,
    computed,
    onMounted,
    ref,
} from '@vue/composition-api'
import YubinBango from '@/ts/yubinbango-core'

// Component
import Nl2br from 'vue-nl2br'

// Store
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as InputStoreKey } from '@/store/Input'
import { StoreKey as ErrorStoreKey } from '@/store/Error'
import { StoreKey as ValidatedStoreKey } from '@/store/Validated'

// Util
import { useValidate } from '@/ts/util/validate'

export default defineComponent({
    components: {
        Nl2br,
    },
    setup(_prop, { root }) {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }
        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }
        const validatedStore = inject(ValidatedStoreKey)
        if (!validatedStore) {
            throw new Error(`${ValidatedStoreKey} is not provided`)
        }

        const zipInputted = ref(false)
        const addressInputted = ref(false)

        const isRequred = computed<boolean>(() => {
            return (
                inputStore.selectedHowto !== null &&
                inputStore.selectedHowto.has_address == '1'
            )
        })

        const validateZipHandler = useValidate(
            {
                required: isRequred,
            },
            (result, flag, inputted) => {
                validatedStore.zip = flag
                zipInputted.value = inputted as boolean

                const messages: string[] = []
                if (result.required === false && isRequred.value) {
                    messages.push(formStore.error_message.error_zip || '')
                }

                if (messages.length) {
                    errorStore.zip.value = [...messages]
                } else {
                    errorStore.zip.value = null
                }
            }
        )
        const zipFieldClass = computed(() => {
            return {
                'm-required': isRequred.value,
                'm-invalid':
                    errorStore.zip.value !== null || validatedStore.zip === -1,
                'm-verify':
                    (!isRequred.value && zipInputted.value) ||
                    (isRequred.value && validatedStore.zip === 1),
            }
        })

        const validateAddressHandler = useValidate(
            {
                required: isRequred,
            },
            (result, flag, inputted) => {
                validatedStore.address = flag
                addressInputted.value = inputted as boolean

                const messages: string[] = []
                if (result.required === false && isRequred.value) {
                    messages.push(formStore.error_message.error_address || '')
                }

                if (messages.length) {
                    errorStore.address.value = [...messages]
                } else {
                    errorStore.address.value = null
                }
            }
        )
        const addressFieldClass = computed(() => {
            return {
                'm-required': isRequred.value,
                'm-invalid':
                    errorStore.address.value !== null ||
                    validatedStore.address === -1,
                'm-verify':
                    (!isRequred.value && addressInputted.value) ||
                    (isRequred.value && validatedStore.address === 1),
            }
        })

        const zipCompute = computed(() => {
            return inputStore.zip
        })

        watch(isRequred, () => {
            validateZipHandler(inputStore.zip)
            validateAddressHandler(inputStore.address)
        })

        watch(zipCompute, (newVal) => {
            if (newVal) {
                new YubinBango.Core(newVal, function (addr) {
                    if (addr.region_id) {
                        inputStore.address = `${addr.region}${addr.locality}${addr.street}${addr.extended}`
                        validateAddressHandler(inputStore.address)
                    }
                })
            }
        })

        onMounted(() => {
            if (inputStore.zip) {
                validateZipHandler(inputStore.zip)
            }
            if (inputStore.address) {
                validateAddressHandler(inputStore.address)
            }
        })

        return {
            address_field_zip_placeholder: computed(() => {
                return root.$data.address_field_zip_placeholder ?? '例）5100834'
            }),
            address_field_placeholder: computed(() => {
                return (
                    root.$data.address_field_placeholder ??
                    '例）三重県四日市市ときわ1丁目2-18'
                )
            }),
            formStore,
            inputStore,
            errorStore,
            validatedStore,
            isRequred,
            zipFieldClass,
            addressFieldClass,
            validateZipHandler,
            validateAddressHandler,
        }
    },
})
